import PaymentMethod from './models'

export default PaymentMethod
